module.exports = __webpack_public_path__ + "static/media/06.cb54ec38.jpg";